import { render, staticRenderFns } from "./AbTestRegister.vue?vue&type=template&id=e080138e&scoped=true"
import script from "./AbTestRegister.vue?vue&type=script&lang=js"
export * from "./AbTestRegister.vue?vue&type=script&lang=js"
import style0 from "./AbTestRegister.vue?vue&type=style&index=0&id=e080138e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e080138e",
  null
  
)

export default component.exports